/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsassistanthint2Inputs */

const en_statsassistanthint2 = /** @type {(inputs: Statsassistanthint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages the assistant acted on, and how often that was undone.`)
};

const de_statsassistanthint2 = /** @type {(inputs: Statsassistanthint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachrichten, auf die der Assistent reagiert hat, und wie oft das rückgängig gemacht wurde.`)
};

/**
* | output |
* | --- |
* | "Messages the assistant acted on, and how often that was undone." |
*
* @param {Statsassistanthint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsassistanthint2 = /** @type {((inputs?: Statsassistanthint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsassistanthint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsassistanthint2(inputs)
	return de_statsassistanthint2(inputs)
});
export { statsassistanthint2 as "statsAssistantHint" }